const TIMEZONES = [
  {
    label: 'Europe/Madrid',
    value: 'Europe/Madrid',
  },
  {
    label: 'America/Sao_Paulo',
    value: 'America/Sao_Paulo',
  },
  {
    label: 'America/Buenos_Aires',
    value: 'America/Buenos_Aires',
  },
  {
    label: 'America/Santiago',
    value: 'America/Santiago',
  },
  {
    label: 'America/Los_Angeles',
    value: 'America/Los_Angeles',
  },
  {
    label: 'Europe/Lisbon',
    value: 'Europe/Lisbon',
  },
];

export default TIMEZONES;
